import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { educationPage } from '../../data/applicationPages';
export function EducationPage() {
  return <ApplicationPage content={educationPage} data-id="element-1911" data-mp="6qq2hz0g4b9t" />;
}